<template>
  <div class="index">
    <el-breadcrumb separator="|">
      <el-breadcrumb-item v-for="(v, i, k) in crumbsArr" :key="k">
        <span class="greyColor" v-if="i != crumbsArr.length - 1">{{ v }}</span>
        <span class="greyColor" :class="{ primaryColor: !isAddLast }" v-else
          ><slot>{{ v }}</slot></span
        ></el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-if="isAddLast"
        :key="kk"
        v-for="(item, ii, kk) in extraArr"
      >
        <span
          class="greyColor"
          :class="{ primaryColor: isAddLast && ii == extraArr.length - 1 }"
        >
          {{ item }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="right" v-if="isOperate">
      <p @click="videoInfo" finger>
        <i class="iconfont icon-a-zu430"></i>
        视频讲解
      </p>
      <p @click="manualInfo" finger slot="reference">
        <i class="iconfont icon-a-lujing314"></i>
        操作手册
      </p>
    </div>

    <!-- 播放弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      class="noBacDig"
      :visible.sync="videoDig"
      width="50%"
    >
      <div v-if="videoDig" style="text-align: center">
        <video-player
          class="vjs-big-play-centered"
          ref="videoPlayer"
          :options="playerOptions"
        >
        </video-player>
      </div>
      <span slot="footer" class="dialog-footer">
        <span
          finger
          style="
            position: absolute;
            top: 30px;
            right: -30px;
            color: #fff;
            font-size: 30px;
            font-weight: 300;
          "
          @click="videoDig = false"
          class="iconfont icon-close"
        ></span>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" :modal="false" width="980px">
      <div class="header">
        <div>
          <span class="names" v-for="(v, i) in headNAme" :key="i">
            <span style="margin: 0 25px" v-if="i != 0">|</span>
            <span
              :style="{
                color:
                  i == headNAme.length - 1
                    ? 'var(--primary-color,#245BBF)'
                    : '#333333',
              }"
              >{{ v }}</span
            >
          </span>
        </div>
        <span class="close" finger @click="dialogVisible = false">
          <i class="iconfont icon-a-lujing2"></i>
          关闭
        </span>
      </div>
      <div class="cab">
        <el-scrollbar style="height: 576px">
          <div class="content">
            <div class="kindName">{{ headNAme[headNAme.length - 1] }}</div>
            <div v-html="msg" class="msg" id="manualPic"></div>
          </div>
        </el-scrollbar>
      </div>
      <div class="footer" @click="moreInfo()">更多>></div>
    </el-dialog>
  </div>
</template>

<script>
import { getNavDetail } from "@/components/libs/js/crumbs.js";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "video.js/dist/video-js.min.css";
import { uploadVideoImg } from "@/components/libs/uploadVideoImg";
import { mixin } from "@/components/libs/mixs";
export default {
  components: { videoPlayer },
  mixins: [mixin, uploadVideoImg],
  data() {
    return {
      crumbsArr: [],
      isAddLast: this.extraArr.length > 0,
      obj: {}, //当前页面数据
      //播放器参数
      playerOptions: {
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        poster: "", // 封面地址
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
        autoplay: true,
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      },
      videoDig: false,
      visible: false,
      headNAme: [],
      msg: "",
      dialogVisible: false,
      id: "", //分类id
    };
  },
  props: {
    constant: {
      default: () => false,
    },
    extraArr: {
      default: () => [],
    },
    // 是否显示操作
    isOperate: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    $route: {
      handler(newD, oldD) {
        // 标签展示先加成这样 ，后面分类模块还要改
        this.crumbsArr = getNavDetail(this.$route.path);
      },
      deep: true,
      immediate: true, // 初始也执行
    },
  },
  mounted() {},
  created() {
    // var location = window.LS.get("currentArr") || '';
    // if(location!=''){
    //   location = location.split(',')
    //   this.crumbsArr = location
    // }
    this.init();
  },
  methods: {
    //resourcesId
    init() {
      var url = this.$route.path;
      var arr = JSON.parse(window.LS.get("SY")).menu;
      this.obj = this.getName(url, arr);
    },
    getName(url, arr) {
      for (const item of arr) {
        if (item.url && item.url.split("?")[0] === url) return item;
        if (item.children && item.children.length) {
          const _item = this.getName(url, item.children);
          if (_item) return _item;
        }
      }
    },
    //视频讲解
    videoInfo() {
      this.axios({
        url: `/service-cms-app/app/cms-video-explain/get-by-id?resourcesId=${this.obj.id}`,
        params: {
          pageNo: 1,
          pageSize: 10,
        },
        interface: 1,
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.total == 0)
            return this.$message.warning(
              "当前页面还未配置讲解视频，请联系平台运营人员进行处理。"
            );
          this.played(res.data.data.data[0]);
        }
      });
    },
    //播放视频
    played(item) {
      this.playerOptions.sources = [
        {
          type: "video/mp4",
          src: item.fileUrl,
        },
      ];
      this.videoDig = true;
    },
    // 操作手册
    manualInfo() {
      this.axios({
        url: `/service-cms-app/app/operation-manual/get-by-id?resourcesId=${this.obj.id}`,
        interface: 1,
      }).then((res) => {
        if (res.data.code == 0) {
          if (!res.data.data.id)
            return this.$message.warning(
              "当前页面还未操作手册，请联系平台运营人员进行处理。"
            );
          this.headNAme = res.data.data.name.split("/");
          this.msg = res.data.data.content;
          this.id = res.data.data.catalogId;
          this.dialogVisible = true;
        }
      });
    },
    moreInfo() {
      let routeUrl = this.$router.resolve({
        path: `/helpCenter/manual?type=1&id=${this.id}`,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.greyColor {
  color: #333;
  &.primaryColor {
    color: @primaryColor;
  }
}
.index {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .right {
    display: flex;
    align-items: center;
    margin-right: 20px;
    p {
      margin-left: 20px;
      color: #999999;
      font-size: 12px;
      i {
        color: #999999;
        font-size: 14px;
        margin-right: 6px;
      }
      &:hover {
        color: @primaryColor;
        i {
          color: @primaryColor;
        }
      }
    }
  }
}

.header {
  height: 40px;
  background: #f7f7f7;
  line-height: 40px;
  padding: 0 25px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  .names {
    color: #333333;
  }
  .close {
    i {
      font-size: 14px;
      color: #999999;
    }
  }
}
.content {
  width: 930px;
  padding: 0 25px;
  background: #ffffff;
  .kindName {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e5e5e5;
    padding: 25px 0;
  }
  .msg {
    width: 100%;
    margin-top: 25px;
  }
  /deep/ img {
    width: 100%;
  }
}
.footer {
  padding: 0 25px;
  text-align: right;
  height: 40px;
  background: #f7f7f7;
  line-height: 40px;
  color: @primaryColor;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: visible;
}

/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/ .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  right: 85px;
  top: 175px;
}
</style>
